import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { Toast } from 'ngx-toastr';
import { Clipboard } from '@capacitor/clipboard';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  standalone: true,
  preserveWhitespaces: false,
  imports: [IonIcon, CommonModule],
})
export class ToastComponent extends Toast {
  toastType = this.toastPackage.toastType;

  errorCopied: boolean = false;

  dismiss() {
    // console.log(this.toastType);
    this.toastPackage.toastRef.close();
  }
  async copyError() {
    this.errorCopied = true;

    setTimeout(() => {
      this.errorCopied = false;
    }, 5000);

    await Clipboard.write({
      string: JSON.stringify(this.toastPackage.config.payload),
    });
  }
}
